<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-07 14:55:09
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:27:46
-->
<template>
  <div class="bigbox">
    <v-card class="mb-6">
      <v-card-title class="pa-0">
        <v-icon @click="switchover" class="material-icons margin1">
          {{ valuestatus ? "chevron_right" : "expand_more" }}
        </v-icon>
        <div
          :class="readonly ? '' : indeterminate ? 'iconbox' : ''"
          class="d-flex"
        >
          <!--  :label="copylist.table_description" -->
          <v-checkbox
            v-model="allChecked"
            :readonly="readonly"
            :disabled="disabled"
            :color="readonly ? '#cccccc' : 'primary'"
            style="white-space: nowrap"
            :indeterminate="indeterminate"
            @change="allchecked"
            class="checkbox"
          ></v-checkbox>
          <div
            class="text-body-m mt-5"
            :style="{
              color: disabled ? 'rgba(0,0,0,0.78)' : 'rgba(0,0,0,0.78)',
            }"
          >
            {{ copylist.table_description }}
          </div>
        </div>
      </v-card-title>
      <v-card-text
        :style="{
          display: valuestatus ? 'block' : 'none',
          'padding-left': '55px',
        }"
        class="cardtext py-0 pb-8"
      >
        <v-row>
          <v-col
            cols="12"
            sm="6"
            v-for="(item1, index) in copylist.mrbase_sys_datamodel_field"
            :key="index"
          >
            <div class="d-flex">
              <!-- :label="item1.field_name" -->
              <v-checkbox
                :readonly="readonly"
                :color="readonly ? '#cccccc' : 'primary'"
                :true-value="1"
                :disabled="disabled"
                :false-value="0"
                v-model="item1.is_international"
                @change="changeindeter"
                class="checkbox"
              ></v-checkbox>
              <span
                style="margin-top: 6px"
                :style="{
                  color: disabled ? 'rgba(0,0,0,0.78)' : 'rgba(0,0,0,0.78)',
                }"
              >
                {{ item1.field_name }}
              </span>
            </div>
            <span
              class="p1"
              :style="{
                color: disabled ? 'rgba(0,0,0,0.78)' : 'rgba(0,0,0,0.78)',
              }"
              >{{ INT(item1.field_description) }}</span
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- <mrc_ess_submitBtn @success='success'
              @cancel='cancel'
              v-if='!readonly'></mrc_ess_submitBtn> -->
  </div>
</template>

<script>
import {
  valuedetail,
  valueupdate,
} from "@/service/api/internationalization.js";
export default {
  components: {},
  props: {
    list: {
      type: Object,
      default: [],
    },
    readonlyed: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      readonly: false, //读写状态
      valuestatus: false,
      indeterminate: null, //半选状态
      copylist: [],
    };
  },
  created() {},
  async mounted() {
    this.readonly = this.readonlyed;
    // this.copylist = this.$clone(this.list)
    this.copylist = JSON.parse(JSON.stringify(this.list));
    // console.log(this.list);
    this.changeindeter();
  },
  methods: {
    handleEdit() {
      this.readonly = !this.readonly;
      this.$store.commit("set_iconstatus", this.readonly);
    },
    getchildrenlist() {
      // console.log(11);this.$set(this.copylist,is_international,1)
      // console.log(this.allChecked, this.allchecked ? this.$set(this.copylist, 'is_international', 1) : this.$set(this.copylist, 'is_international', 0));
      this.allChecked
        ? (this.copylist.is_international = 1)
        : (this.copylist.is_international = 0);
      // this.allChecked ? this.$set(this.copylist, 'is_international', 1) : this.$set(this.copylist, 'is_international', 0)
      this.$emit("getchildrenlist", this.copylist);
    },
    success() {
      //提交
      // console.log(this.copylist)
      // valueupdate({
      //   table_uuids: '',
      //   field_uuids: ''
      // })
    },
    switchover() {
      this.valuestatus = !this.valuestatus;
    },
    allchecked() {
      this.getchildrenlist();
    },
    changeindeter() {
      this.getchildrenlist();
      if (this.copylist.mrbase_sys_datamodel_field.length > 0) {
        if (
          this.copylist.mrbase_sys_datamodel_field.some((item) => {
            //有一个选中就出现
            return item.is_international == 1;
          })
        ) {
          // console.log(1, this.indeterminate);
          this.indeterminate = true;
        }
        if (
          this.copylist.mrbase_sys_datamodel_field.every((item) => {
            //全部未就消失
            return item.is_international == 0;
          })
        ) {
          // console.log(2);
          this.indeterminate = false;
        }
        if (
          this.copylist.mrbase_sys_datamodel_field.every((item) => {
            //全部选中就消失
            return item.is_international == 1;
          })
        ) {
          // console.log(3);
          this.indeterminate = null;
        }
      }
    },
  },
  computed: {
    allChecked: {
      get() {
        //全选状态
        if (this.copylist.mrbase_sys_datamodel_field) {
          return this.copylist.mrbase_sys_datamodel_field.every((item) => {
            return item.is_international == 1;
          });
        }
      },
      set(val) {
        val == 1 ? (this.indeterminate = null) : (this.indeterminate = false);
        this.copylist.mrbase_sys_datamodel_field.forEach((item) => {
          val == 1 ? (item.is_international = 1) : (item.is_international = 0);
        });
      },
    },
  },
  watch: {
    list: {
      handler(val) {
        // this.copylist = val
        this.copylist = JSON.parse(JSON.stringify(val));
      },
      deep: true,
    },
    readonlyed(v) {
      // console.log(v);
      this.readonly = v;
    },
  },
};
</script>

<style scoped>
.bigbox /deep/ .v-label {
  padding-left: 0px;
}
.bigbox /deep/ .v-card__title {
  padding: 0 0;
}
.cardtext /deep/ .v-input__control {
  height: 25px;
}
.cardtext /deep/ .v-input--selection-controls {
  margin-top: 4px;
}
.padding-left {
  padding: 0 0 0 50px;
}
.iconbox /deep/ .theme--light.v-icon {
  color: var(--main-color) !important;
}
.p1 {
  /* color: rgba(0, 0, 0, 0.38); */
  display: block;
  text-align: left;
  padding-left: 33px;
}
.cardbox {
  margin-bottom: 24px;
}
.margin1 {
  margin: 0 15px;
}
</style>
